import React from 'react';

interface RatingProps {
  value: number;
  max: number;
}

const StarRating: React.FC<RatingProps> = ({ value, max }) => {
  // Calculate the number of filled and empty stars
  const filledStars = Math.min(value, max);
  const emptyStars = max - filledStars;

  return (
    <div className="flex items-center">
      {[...Array(filledStars)].map((_, index) => (
        <span key={index} className="text-yellow-500 text-2xl">
          ★
        </span>
      ))}
      {[...Array(emptyStars)].map((_, index) => (
        <span key={index} className="text-gray-300 text-2xl">
          ☆
        </span>
      ))}
    </div>
  );
};

export default StarRating;
